import { render } from "./UserWithdraw.vue?vue&type=template&id=62adefcb&scoped=true"
import script from "./UserWithdraw.vue?vue&type=script&lang=js"
export * from "./UserWithdraw.vue?vue&type=script&lang=js"

import "./UserWithdraw.vue?vue&type=style&index=0&id=62adefcb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62adefcb"]])

export default __exports__